module.exports = __webpack_public_path__ + "static/media/teacher-card-img.4699c3c6.png";